import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import { CalculatorDebug } from './CalculatorDebug';
import ErrorBox from '../components/messages/ErrorBox';


export const CalculatorRouter = () => {
  return (        
    <ErrorBox>
      <Switch>                  
          <Route exact path="/calculator" component={CalculatorDebug} />                          
      </Switch>
    </ErrorBox>    
  );
};
